import { playersIsLoadingSelector, playersInfoSelector } from "modules/teams/store/players/selectors"
import { useSelector } from "react-redux"

export const usePlayers = () => {
  const isLoading = useSelector(playersIsLoadingSelector);
  const info = useSelector(playersInfoSelector);

  return {
    isLoading,
    info,
  };
}